import { useRouter } from 'next/router';

import { AppState, Auth0Provider } from '@auth0/auth0-react';

import { AUTH_AUDIENCE, AUTH_CLIENT_ID, AUTH_DOMAIN, AUTH_SCOPE } from '../constants/config';

type AuthContextProps = {
  children: React.ReactNode;
};

export const AuthProvider: React.FC<AuthContextProps> = ({ children }) => {
  const router = useRouter();

  const onRedirectCallback = (appState: AppState) => {
    router.replace(appState?.returnTo || '/');
  };

  return (
    <Auth0Provider
      authorizationParams={{
        audience: AUTH_AUDIENCE,
        redirect_uri: typeof window !== 'undefined' && window.location.origin,
        scope: `email profile ${AUTH_SCOPE}`,
      }}
      cacheLocation="localstorage"
      clientId={AUTH_CLIENT_ID}
      domain={AUTH_DOMAIN}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  );
};
